export const LikeIcon: React.FC<any> = ({ className }) => {
  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{
        __html: `
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="inherit">
        <g opacity="0.6" clip-path="url(#clip0_2059_4093)">
            <path d="M4.47266 5.11194H2.72266C2.25853 5.11194 1.81341 5.29631 1.48522 5.6245C1.15703 5.95269 0.972656 6.39781 0.972656 6.86194L0.972656 11.5286C0.972656 11.9927 1.15703 12.4379 1.48522 12.766C1.81341 13.0942 2.25853 13.2786 2.72266 13.2786H4.47266V5.11194Z" fill="inherit"/>
            <path d="M9.1394 5.11195L9.46315 3.17061C9.51923 2.88131 9.47715 2.58156 9.34359 2.31888C9.21003 2.05619 8.99262 1.84559 8.72582 1.72045C8.41984 1.58687 8.07442 1.57508 7.76005 1.6875C7.44568 1.79991 7.18605 2.02805 7.03415 2.32536L5.6394 5.11195V13.2786H13.8061L14.9727 6.86195V5.11195H9.1394Z" fill="inherit"/>
        </g>
        <defs>
            <clipPath id="clip0_2059_4093">
            <rect width="14" height="14" fill="white" transform="translate(0.972656 0.445312)"/>
            </clipPath>
        </defs>
        </svg>
    `,
      }}
    />
  );
};
